import React from "react";
import flowers from "../data/buchete";
import FlowerContainer from "../components/FlowerContainer";

const Buchete = () => {
  return (
    <FlowerContainer
      flowers={flowers}
      title="Buchete"
      subtitle="Descoperă colecția noastră de buchete elegante, potrivite pentru orice ocazie, indiferent de sezon."
      storageKey="BUCHETE_SCROLL_POSITION"
    />
  );
};

export default Buchete;
